// ** global usage
import { LayoutService } from './layout.service';
import { LanguageService } from './language.service';

// ** primeNg
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

// ** 靜態資料呼叫的 service
import { HomeService } from './home.service';
import { NewsService } from './news.service';
import { ProductsService } from './products.service';
import { SuccessService } from './success.service';

export const services = [
	HomeService,
	MessageService,
	ConfirmationService,
	DialogService,
	LayoutService,
	LanguageService,
	NewsService,
	ProductsService,
	SuccessService,
];

export * from './home.service';
export * from './language.service';
export * from 'primeng/api';
